/* import __COLOCATED_TEMPLATE__ from './launcher.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();